import { useSyncExternalStore } from 'react';

import { oneTrustClient, type Consent } from 'services/oneTrust';

export type { Consent };

/**
 * Single source of truth for the Partner's cookie consent, read from the
 * OneTrust SDK via `useSyncExternalStore` (default-deny until OneTrust
 * confirms).
 *
 * Every feature that gates on consent should read it from here, never from the
 * OneTrust global directly.
 */
export function useConsent(): Consent {
  return useSyncExternalStore(
    oneTrustClient.subscribe,
    oneTrustClient.getSnapshot,
    oneTrustClient.getServerSnapshot,
  );
}
